import { HttpMethod, Locales } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { User } from '~/store/user/http/types'

type ChangeLanguageRequestBody = {
  shortcut: string
}

class UserAPI extends Http {
  load = (inSelectedProperty: boolean): Promise<User> => {
    if (inSelectedProperty) {
      return this.callAuthWithPropertyAPI<null, User>(
        HttpMethod.GET,
        { path: APIPaths.USER_USER_CURRENT },
        null,
      )
    }

    return this.callAuthAPI<null, User>(HttpMethod.GET, { path: APIPaths.USER_USER_CURRENT }, null)
  }

  changeLanguage = (locale: Locales): Promise<null> => {
    return this.callAuthWithPropertyAPI<ChangeLanguageRequestBody, null>(
      HttpMethod.PUT,
      { path: APIPaths.USER_USER_CHANGE_LANGUAGE },
      {
        shortcut: locale,
      },
    )
  }
}

export const useUserAPI = (): UserAPI => {
  return new UserAPI()
}
